export const sxStyles = {
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
};
